import { Box, Flex } from '@chakra-ui/core'
import React, { memo, useMemo } from 'react'
import keys from 'constants/keys'
import { StatusBadge, BadgeType } from 'components/NewsFeed/PersonalView/StatusBadge'

interface IProps {
  avatar: string
  status: number
  houraUntilEnd: number
}
export const CircleTask = memo(({ avatar, status, houraUntilEnd }: IProps) => {
  // Определяем тип и значение badge на основе статуса и времени до окончания
  const badge = useMemo((): { type: BadgeType; value?: number } => {
    // Если задача выполнена, badge не показываем
    if (status === keys.TASK_STATUSES.DONE.value) {
      return { type: 'none' }
    }

    // Если задача в процессе и просрочена
    if (
      (status === keys.TASK_STATUSES.TODO.value || status === keys.TASK_STATUSES.INPROGRESS.value) &&
      houraUntilEnd < 0
    ) {
      return { type: 'overdue' }
    }

    // Если задача в процессе и не просрочена
    if (
      (status === keys.TASK_STATUSES.TODO.value || status === keys.TASK_STATUSES.INPROGRESS.value) &&
      houraUntilEnd >= 0
    ) {
      return { type: 'hours', value: Math.floor(houraUntilEnd) }
    }

    return { type: 'none' }
  }, [status, houraUntilEnd])

  return (
    <Flex position="relative" flexDirection="column" alignItems="center" justifyContent="flex-start">
      <Box
        position="relative"
        w="90px"
        h="90px"
        borderRadius="50%"
        overflow="hidden"
        backgroundImage={avatar ? `url(${avatar})` : 'none'}
        bg={avatar ? 'white' : 'grey'}
        backgroundSize="cover"
        border="2px solid white"
        backgroundPosition="top"
        boxShadow="0px 0px 2px 0px grey"
      />
      <StatusBadge type={badge.type} value={badge.value} width="110px" bottom="0" />
    </Flex>
  )
})
